import { InjectionToken } from '@angular/core';

/** Where `domainAdminGuard` sends a non-admin — an in-shell "you don't have access" card, never login. */
export const ADMIN_RESTRICTED_ROUTE = new InjectionToken<string[]>('PV_ADMIN_RESTRICTED_ROUTE', {
  providedIn: 'root',
  factory: () => ['/app/access-denied'],
});
